import { Controller } from "react-hook-form";
import { lang } from "../../Utils/lang";
import { TextField } from "@mui/material";

export default function Delegate(props: any) {
  const { control } = props;

  return (
    <>
      <Controller
        name="firstName"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="firstName"
            label={lang.firstName}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="lastName"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="lastName"
            label={lang.lastName}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="cnp"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="cnp"
            label={lang.CNP}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="series"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="series"
            label={lang.series}
            size="small"
            variant="outlined"
          />
        )}
      />
      <Controller
        name="nr"
        defaultValue={undefined}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <TextField
            onChange={onChange}
            fullWidth
            style={{
              marginBottom: 15,
            }}
            value={value}
            error={!!error}
            helperText={error?.message}
            id="nr"
            label={lang.nr}
            size="small"
            variant="outlined"
          />
        )}
      />
    </>
  );
}
